import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { generateSalaryComponents } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';

const useGenerateComponents = () => {
  const { t } = useTranslation('common', { keyPrefix: 'DHTClaSettings' });
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(generateSalaryComponents, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(['DHTClaSettings', 'list']);
      showSnackbar({ severity: 'success', message: t('messages.generated') });
    },
    onError: () => {
      showSnackbar({ severity: 'error', message: t('messages.error') });
    }
  });
  return { isLoading, mutate };
};

export default useGenerateComponents;
